/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BankAccountParam } from './bankAccountParam';
import { MembershipParam } from './membershipParam';


export interface UpdateUserParam { 
    /**
     * Id Hash. UUI (Unique User Identifier). Maximum length 88. Mandatory in the PUT Service.
     */
    idHash: string;
    /**
     * Login Name. Maximum length 150
     */
    loginName: string;
    /**
     * Password. Maximum length 50
     */
    password: string;
    /**
     * Name. Maximum lenght 150
     */
    name: string;
    /**
     * First Surname. Maximum lenght 150
     */
    firstSurname: string;
    /**
     * Second Surname. Maximum lenght 150
     */
    secondSurname?: string;
    /**
     * NIF. Maximum length 50
     */
    nif: string;
    /**
     * KYC Maindata Verified
     */
    kycMaindataVerified?: boolean;
    /**
     * Email. Maximum length 150
     */
    email: string;
    /**
     * Email Verified
     */
    emailVerified?: boolean;
    /**
     * Address. Maximum lenght 255
     */
    address?: string;
    /**
     * Postal Code. Maximum lenght 12
     */
    postalCode?: string;
    /**
     * Country. Maximum lenght 150
     */
    country?: string;
    /**
     * Province. Maximum lenght 150
     */
    province?: string;
    /**
     * City. Maximum lenght 255
     */
    city?: string;
    /**
     * Country Code. Maximum lenght 3
     */
    countryCode?: string;
    /**
     * Country Name. Maximum lenght 150
     */
    countryName?: string;
    /**
     * Region Code. Maximum lenght 24
     */
    regionCode?: string;
    /**
     * Region Name. Maximum lenght 150
     */
    regionName?: string;
    /**
     * City Code. Maximum lenght 100
     */
    cityCode?: string;
    /**
     * City Name. Maximum lenght 150
     */
    cityName?: string;
    /**
     * KYC Address Verified
     */
    kycAddressVerified?: boolean;
    /**
     * Birth place Country Code. Maximum lenght 3
     */
    birthPlaceCountryCode?: string;
    birthPlacecountryName?: string;
    /**
     * Birth place Region Code. Maximum lenght 24
     */
    birthPlaceRegionCode?: string;
    birthPlaceregionName?: string;
    /**
     * Birth place City Code. Maximum lenght 100
     */
    birthPlaceCityCode?: string;
    /**
     * Birth place City Name. Maximum lenght 150
     */
    birthPlaceCityName?: string;
    /**
     * KYC Birth place Verified
     */
    kycBirthPlaceVerified?: boolean;
    /**
     * Telephone. Maximum lenght 50
     */
    telephone?: string;
    /**
     * Telephone Verified
     */
    telephoneVerified?: boolean;
    /**
     * Telephone2. Maximum lenght 50
     */
    telephone2?: string;
    /**
     * Birth Date. Format yyyy-MM-dd HH:mm:ss
     */
    birthDate?: string;
    /**
     * User\'s handwritten signature. Encoded in Base64 format. Maximum length 11 MB
     */
    handwrittenSignature?: UpdateUserParam.HandwrittenSignatureEnum;
    /**
     * Verified data validity expiration date, after which the verification process should be performed again. Format yyyy-MM-dd HH:mm:ss
     */
    dataValidUntil?: string;
    /**
     * Language. Maximum lenght 15
     */
    language?: string;
    /**
     * Role. Maximum lenght 25
     */
    role?: string;
    /**
     * Account Type. Maximum lenght 100
     */
    accountType?: string;
    /**
     * Id External. Maximum lenght 255
     */
    idExternal?: string;
    /**
     * Firebase cloud Message token
     */
    firebaseToken?: string;
    /**
     * Creation Date. Format yyyy-MM-dd HH:mm:ss
     */
    creationDate?: string;
    /**
     * Photo. Encoded in Base64 format. Maximum length 11 MB
     */
    photo?: UpdateUserParam.PhotoEnum;
    /**
     * The user agrees to receive commercial communications.
     */
    agreeCommercialCommunications?: boolean;
    /**
     * Deprecated. Use ExcludedAttributes instead.
     */
    returnPhoto?: boolean;
    /**
     * Department Name. Maximum lenght 50
     */
    department?: string;
    /**
     * BankAccounts. List of bank accounts.
     */
    bankAccounts?: Array<BankAccountParam>;
    /**
     * Memberships. List of memberships.
     */
    memberships?: Array<MembershipParam>;
    /**
     * IncludedAttributes. List of attribute names to be returned. If empty, all attributes are returned. This property is exclusionary with the ExcludedAttributes property.
     */
    includedAttributes?: Array<string>;
    /**
     * ExcludedAttributes. List of attribute names to not be returned. If empty, all attributes are returned. This property is exclusionary with the IncludedAttributes property.
     */
    excludedAttributes?: Array<string>;
    /**
     * Nationalities. List of the countries the user has nationality.
     */
    nationalities?: Array<string>;
    /**
     * True if you want to get the tickets of the user, false otherwise. By default is false
     */
    getTickets?: boolean;
    /**
     * Subject DID
     */
    subjectDid?: string;
    /**
     * Company. Maximum length 255
     */
    company?: string;
    /**
     * Sex. Maximum length 255
     */
    sex?: string;
    /**
     * Bank. Maximum length 255
     */
    bank?: string;
    /**
     * Bank Branch. Maximum length 255
     */
    bankBranch?: string;
    /**
     * Bank Account Control Digit. Maximum length 255
     */
    bankAccountControlDigit?: string;
    /**
     * Bank Account. Maximum length 255
     */
    bankAccount?: string;
    /**
     * Bank IBAN Code. Maximum length 255
     */
    bankIBANCode?: string;
    /**
     * Bank Reference. Maximum length 255
     */
    bankReference?: string;
    /**
     * Partner Create Date. Maximum length 255
     */
    partnerCreateDate?: string;
    /**
     * Partner Last Update Date. Maximum length 255
     */
    partnerLastUpdateDate?: string;
    /**
     * Subscription Number. Maximum length 255
     */
    subscriptionNumber?: string;
    /**
     * Subscription Old Number. Maximum length 255
     */
    subscriptionOldNumber?: string;
    /**
     * Subscription Type. Maximum length 255
     */
    subscriptionType?: string;
    /**
     * Subscription Frequency. Maximum length 255
     */
    subscriptionFrequency?: string;
    /**
     * Subscription Paid State. Maximum length 255
     */
    subscriptionPaidState?: string;
    /**
     * Subscription Marked Price. Maximum length 255
     */
    subscriptionMarkedPrice?: string;
    /**
     * Subscription Discount. Maximum length 255
     */
    subscriptionDiscount?: string;
    /**
     * Subscription Selling Price (marked price minus discount). Maximum length 255
     */
    subscriptionSellingPrice?: string;
    /**
     * Subscription Access Type. Maximum length 255
     */
    subscriptionAccessType?: string;
    /**
     * Subscription Access Type Description. Maximum length 255
     */
    subscriptionAccessTypeDescription?: string;
    /**
     * Subscription Area Name. Maximum length 255
     */
    subscriptionAreaName?: string;
    /**
     * Subscription Area Doors. Maximum length 255
     */
    subscriptionAreaDoors?: string;
    /**
     * Subscription Sector Name. Maximum length 255
     */
    subscriptionSectorName?: string;
    /**
     * Subscription Location. Maximum length 255
     */
    subscriptionLocation?: string;
    /**
     * Subscription Row. Maximum length 255
     */
    subscriptionRow?: string;
    /**
     * Subscription Seat. Maximum length 255
     */
    subscriptionSeat?: string;
    /**
     * Subscription Acquisition Date. Maximum length 255
     */
    subscriptionAcquisitionDate?: string;
    /**
     * Subscription Permission. Maximum length 255
     */
    subscriptionPermission?: string;
    /**
     * Remarks. Maximum length 255
     */
    remarks?: string;
    /**
     * Reference. Maximum length 255
     */
    reference?: string;
    /**
     * Province Code. Maximum length 255
     */
    provinceCode?: string;
    /**
     * Spouse. Values 0 (has no spouse) or 1 (has spouse)
     */
    spouse?: string;
    /**
     * Children number. Values 0 (has no children) or 1 (has one son) or 2...
     */
    childrenNumber?: string;
    /**
     * Pay Hash Credit Card
     */
    payHashCreditCard?: string;
    /**
     * Pay Hash Paypal
     */
    payHashPaypal?: string;
    /**
     * Pay Hash Bizum
     */
    payHashBizum?: string;
    /**
     * Credit Card Not After. Maximum length 255
     */
    payCreditCardNotAfter?: string;
    /**
     * Credit Card Last Digits. Maximum length 255
     */
    payCreditCardLastDigits?: string;
    /**
     * Credit Card Type. Maximum length 255
     */
    payCreditCardType?: string;
    /**
     * User signup referral. Maximum length 255
     */
    userOrigin?: string;
    /**
     * Subscription start date
     */
    subscriptionNotBefore?: string;
    /**
     * Subscription end date
     */
    subscriptionNotAfter?: string;
    /**
     * QR image
     */
    qr?: string;
    extraAttributes?: { [key: string]: string; };
    /**
     * Birth place Region Name. Maximum lenght 150
     */
    birthPlaceRegionName?: string;
    /**
     * Birth place Country Name. Maximum lenght 150
     */
    birthPlaceCountryName?: string;
    extraAttributesBlob?: { [key: string]: string; };
}
export namespace UpdateUserParam {
    export type HandwrittenSignatureEnum = '[B@75a118e6';
    export const HandwrittenSignatureEnum = {
        B75a118e6: '[B@75a118e6' as HandwrittenSignatureEnum
    };
    export type PhotoEnum = '[B@1d540566';
    export const PhotoEnum = {
        B1d540566: '[B@1d540566' as PhotoEnum
    };
}


